import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import {
  Breadcrumbs,
  Button,
  Grid,
  SvgIcon,
  Typography
} from '@mui/material';

import {
  PlusCircle as PlusCircleIcon
} from 'react-feather';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Header({ className, ...rest }) {

  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justify="space-between"
      spacing={3}
      {...rest}
    >

      {/* Page Title */}
      <Grid item>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Typography
            variant="h3"
            color="textPrimary"
            style={{ marginLeft: "1em" }}
          >
            Variant Products List
          </Typography>
        </Breadcrumbs>
      </Grid>

    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;